module.exports = __webpack_public_path__ + "static/media/img-mission.726e09d2.svg";